<template>
  <v-dialog
    v-model="dialog"
    max-width="1000px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="info"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-information-outline
            </v-icon>
          </v-btn>
        </template>
        <span>View Taken Applications</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="View Taken Leave Applications"
      :text="entitlement.employee.person.name + ' ('+ entitlement.leave_type.name +')'"
      class="mb-0"
    >
      <v-container>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="leaveApplications"
        >
          <template v-slot:item.latest_status.name="{ item }">
            <span
              :class="{ 
                'warning--text': (item.latest_status.id === 100),
                'red--text': (item.latest_status.id === 500), 
                'grey--text': (item.latest_status.id === 501), 
                'green--text': (item.latest_status.id === 200) 
              }"
            >
              {{ item.latest_status.name }}
            </span>
          </template>

          <template v-slot:item.action="{ item }">
            <setup-leaves-entitlements-dialog-cancel-leave-applications
              v-if="![100,500,501].includes(item.latest_status.id)"
              :application="item"
              @cancel="refreshData"
            />
          </template>
        </v-data-table>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      SetupLeavesEntitlementsDialogCancelLeaveApplications: () => import('@/components/setup/leaves/entitlements/DialogCancelLeaveApplications'),
    },
    props: {
      entitlement: {
        type: Object,
        default: null,
      },    
    },
    data () {
      return {
        dialog: false,
        loading: false,
        headers: [
          {
            text: 'Type',
            align: 'left',
            value: 'leave_entitlement.leave_type.name',
          },
          {
            text: 'Start Date',
            align: 'left',
            value: 'start_date',
          },
          {
            text: 'End Date',
            align: 'left',
            value: 'end_date',
          },
          {
            text: 'Days',
            align: 'left',
            value: 'requested_days',
          },
          {
            text: 'Status',
            align: 'left',
            sortable: false,
            value: 'latest_status.name',
          },
          {
            text: 'Last Update At',
            align: 'left',
            sortable: false,
            value: 'latest_updated_at',
          },
          {
            text: '',
            align: 'center',
            sortable: false,
            value: 'action',
          },
        ],
        leaveApplications: [],
      }
    },

    watch: {
      dialog: function (value) {
        if (value) {
          this.loadLeaveApplications()
        }
      },
    },

    methods: {
      loadLeaveApplications () {
        this.loading = true

        this.$api.entitlementLeaveApplications().list(this.entitlement.id)
          .then(res => {
            this.leaveApplications = []
            res.data.map(application => {
              let approvals = ((application.approval_request || {}).approvals || [])
            
              const sortedApprovals = _.orderBy(approvals, ['created_at'], ['asc'])
              const latestApproval = _.orderBy(approvals, ['created_at'], ['desc'])[0]

              this.leaveApplications.push({ 
                ...application, 
                latest_status: latestApproval.status, 
                latest_updated_at: latestApproval.created_at,
                approvals: sortedApprovals, 
              })
            })

            this.leaveApplications = _.orderBy(this.leaveApplications, ['latest_status.id', 'created_at'], ['asc', 'desc'])
            this.loading = false
          })
      },

      refreshData () {
        this.loadLeaveApplications()
        this.$emit('cancel')
      },
    },
  }
</script>
